import React, { useContext } from 'react';
import { Input, Tooltip } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import {
	ChangeCategoryPositionContext,
	IChangeCategoryPositionContext,
} from '../../../../../changeCategoryPositionState/changeCategoryPositionContext';
import style from './SearchField.module.scss';

const SearchField: React.FC = () => {
	const { changeSelectSearchString, selectSearchString } =
		useContext<IChangeCategoryPositionContext>(ChangeCategoryPositionContext);
	const { t } = useTranslation('global');

	return (
		<Input
			className={style.searchInput}
			onChange={(e) => changeSelectSearchString(e.target.value)}
			onKeyDown={(e) => e.stopPropagation()} // To fix cleanup restaurant multiple select when press backspace
			value={selectSearchString}
			placeholder={t('searchPlaceholder')}
			suffix={
				<Tooltip title={t('searchPlaceholder')}>
					<SearchOutlined className={style.searchIcon} />
				</Tooltip>
			}
		/>
	);
};

export default SearchField;
